import { toast } from 'sonner';
import { createMutationHook } from '@/hooks/lib/createMutationHook';
import { apiPatch, operationsClient } from '@/lib/api';
import { jobPipelineEndpoints } from '@/lib/api/endpoints';
import { jobPipelineKeys } from '@/lib/queryKeys';
import type { JobPipeline, UpdatePipelineDto } from '@/types/pipeline';

export const useUpdatePipeline = createMutationHook<
  JobPipeline,
  UpdatePipelineDto & { id: string }
>({
  mutationFn: ({ id, ...dto }) =>
    apiPatch<JobPipeline, UpdatePipelineDto>(
      operationsClient,
      jobPipelineEndpoints.update(id),
      dto,
    ),
  onSuccess: (data, _variables, queryClient) => {
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.lists() });
    void queryClient.invalidateQueries({ queryKey: jobPipelineKeys.detail(data.id) });
    toast.success('Pipeline updated');
  },
});
